<div class="row">
    <div class="col-3">
        <div class="nav-sidebar">
            <small class="text-muted">Bruger: <span *ngIf="this.authService.currentUser">{{this.authService.currentUser.name}}</span></small>

            <h2 class="mt-3  mb-0" style="color: #0B3793;">Kartotek</h2>
            <hr class="mt-0">
            <ul class="list-unstyled">
                <li><a routerLink="/debtors" i18n>Debtors</a></li>
            </ul>
        </div>
    </div>

    <div class="col">
    </div>
</div>
